import { ProcessTypes } from './constants';

export const checkIsLaserProduct = (processType) => {
  return (
    processType === ProcessTypes.LaserEngraved ||
    processType === ProcessTypes.EnhancedImprintsLaser ||
    processType === ProcessTypes.MultiImprtLaserPenBarrl ||
    processType === ProcessTypes.MultiImprtLaserPenCap ||
    processType === ProcessTypes.LaserVendor ||
    processType === ProcessTypes.IlluminatedLaser ||
    processType === ProcessTypes.ColoredIlluminatedLaser
  );
};

export const checkNeedValidateInterval = (processType) => {
  return (
    processType === ProcessTypes.ScreenPrinted ||
    processType === ProcessTypes.DrinkWareRimLine ||
    processType === ProcessTypes.FullColorScreened
  );
};

export const checkAllowMultipleArts = (processType) => {
  return (
    checkIsLaserProduct(processType) ||
    processType === ProcessTypes.HotStamped ||
    processType === ProcessTypes.Deboss ||
    processType === ProcessTypes.DrinkWareRimLine ||
    processType === ProcessTypes.OneClrInkJet ||
    processType === ProcessTypes.FoilFusing
  );
};

export const checkNeedVectorImage = (processType) => {
  return (
    checkIsLaserProduct(processType) ||
    processType === ProcessTypes.HotStamped ||
    processType === ProcessTypes.Deboss ||
    processType === ProcessTypes.Embroidered
  );
};
